import PdfViewer from 'components/shared/PdfViewer';
import { FunctionComponent, useEffect } from 'react';

const AntiSlaveryPolicy: FunctionComponent = () => {
  useEffect(() => {
    document.dispatchEvent(new Event('page-fetched'));
  }, []);

  return <PdfViewer url="/docs/SEENGROUP-Anti-Slavery-Policy-July 2026.pdf" />;
};

export default AntiSlaveryPolicy;
